import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Plus, LogIn } from "lucide-react";
import { api } from "../lib/api";
import { PageHeader, Spinner, EmptyState } from "../components/bits";
import { GroupCard } from "../components/GroupCard";
import { JoinGroupDialog } from "../components/dialogs/JoinGroupDialog";

export default function Groups() {
  const [sp, setSp] = useSearchParams();
  const [groups, setGroups] = useState(null);
  const [join, setJoin] = useState(sp.get("join") === "1");
  const load = () => api.get("/groups").then((r) => setGroups(r.data));
  useEffect(() => { load(); }, []);
  const [filter, setFilter] = useState("all");
  const shown = groups?.filter((g) => filter === "all" || g.status === filter) || [];
  return (
    <div data-testid="groups-page">
      <PageHeader title="Groups" subtitle="All the stokvels, funds and clubs you belong to." action={<><button className="btn-secondary" data-testid="groups-join-btn" onClick={() => setJoin(true)}><LogIn size={16} /> Join group</button><Link className="btn-primary" to="/app/groups/new" data-testid="groups-create-btn"><Plus size={16} /> Create group</Link></>} />
      <div className="flex gap-2 mb-6">{["all", "active", "archived"].map((s) => <button key={s} onClick={() => setFilter(s)} className={`tab-btn ${filter === s ? "tab-btn-active" : ""}`} data-testid={`groups-filter-${s}`}>{s[0].toUpperCase() + s.slice(1)}</button>)}</div>
      {groups === null ? <Spinner /> : shown.length === 0 ? <EmptyState title="No groups here yet" hint="Create a group or join one with an invitation code." action={<Link to="/app/groups/new" className="btn-primary">Create group</Link>} /> : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-5 stagger">{shown.map((g) => <GroupCard key={g.id} g={g} />)}</div>
      )}
      <JoinGroupDialog open={join} onClose={() => { setJoin(false); setSp({}); }} onDone={load} />
    </div>
  );
}
